import { useQuery, UseQueryOptions } from 'react-query';

import { Asset, QUERY_KEYS } from '@24i/nxg-sdk-photon/src';
import { useContentData } from '@24i/nxg-sdk-smartott-shared/src/context/ContentData';

import { useAppConfigQuery } from '../useAppConfigQuery';
import { AssetQuery } from './types';

const useAssetRelatedQuery = (
    { assetId, assetType }: AssetQuery,
    options?: UseQueryOptions<Asset[]>
) => {
    const isOptionsEnabled = options?.enabled !== undefined ? options.enabled : true;
    const { fetchRecommended } = useContentData();
    const { appSettings } = useAppConfigQuery();
    const pageSize = appSettings?.features?.recommendedRow?.pageSize;

    return useQuery<Asset[]>(
        [QUERY_KEYS.assets, QUERY_KEYS.assetRelated, assetId, assetType],
        () => fetchRecommended(assetId, assetType, pageSize),
        {
            ...options,
            enabled: !!assetId && !!assetType && isOptionsEnabled,
        }
    );
};

export default useAssetRelatedQuery;
